export const FETCH_TICKET_START = "FETCH_TICKET_START";
export const FETCH_TICKET_SUCCESS = "FETCH_TICKET_SUCCESS";
export const FETCH_TICKET_FAILURE = "FETCH_TICKET_FAILURE";

export const FETCH_HOLD_TICKETS_SUCCESS = "FETCH_HOLD_TICKETS_SUCCESS";
export const SET_HOLD_TICKET_INDEX = "SET_HOLD_TICKET_INDEX";

export const UPDATE_TICKET_START = "UPDATE_TICKET_START";
export const UPDATE_TICKET_SUCCESS = "UPDATE_TICKET_SUCCESS";
export const UPDATE_TICKET_FAILURE = "UPDATE_TICKET_FAILURE";

export const SELLER_RESPONSIVE_SNACKBAR = "SELLER_RESPONSIVE_SNACKBAR";
export const SELLER_RESPONSIVE_CLEAR_SNACKBAR = "SELLER_RESPONSIVE_CLEAR_SNACKBAR";
